// imports must be "require" (instead of "import") due to module importing mechanism on dev in "packages/web-bff/src/index.js"
const prebid = require('@gumtree/third-party-ads/src/framework/prebid/client/vendor/prebid.external.js');
const intowow = require('@gumtree/third-party-ads/src/framework/intowow/intowow-library.external.js');

export const triggerWebpackBundle = () => {
    // Reference the import so Webpack keeps it during treeshaking, but the reference itself is noop to keep it safe
    void prebid;
    void intowow;
};

export default {
    prebid,
    intowow,
};
